import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { forward_arrow, graph_icon, } from 'asset/icons';
import { fontSizes } from 'appconstants';
import { formItems } from 'config';
import { Button } from 'components/ui/button';
import FormsFunctional from "./index.function"
import Loader from 'components/Loader';


const Forms = () => {
  const {
    labels,
    forms_loading,
    onPressTab
  } = FormsFunctional()

  return (
    <Wrapper className='flex flex-col h-screen'>

      <Text text='Forms' className='font-bold mb-6' size={fontSizes.h26} />

      <div className='rounded-xl border bg-white px-6 py-5 shadow-sm'>
        <div className='flex items-center gap-2 mb-5'>
          <ReactSVG src={graph_icon} />
          <Text
            text='Update Labels'
            className='font-bold'
            size={fontSizes.h22}
          />
        </div>
        {forms_loading ? <Loader /> :

          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            {labels?.map((item: any) => (
              <Button
                key={item?.sectionKey}
                variant="outline"
                className="w-full flex justify-between items-center border-[#E8E8ED]"
                onClick={() => onPressTab(item)}
              >
                <span className="truncate">{item?.name}</span>
                <ReactSVG src={forward_arrow} />
              </Button>
            ))}
          </div>
        }

      </div>
    </Wrapper>
  );
};

export default Forms;
